// extracted by mini-css-extract-plugin
module.exports = {"styledAccordion":"jnzLEeKp","closeDrawerButton":"hrrW1Gx0","documentChatButton":"K_Isq9j6"};